export default __webpack_public_path__ + "static/pipe_building_block-d6b23dc93eefa4895496dd6ee0376f35.mp4";